import http from "../http-common";
/* eslint-disable */
class PelatihanKomentarService {
  pelatihanKomentarList(page, itemPerPage, keyword, kegiatanId) {
    return http.get(
      "/pelatihan/komentar/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&kegiatan_id=" +
        kegiatanId,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      }
    );
  }

  delete(id) {
    return http.delete(`/pelatihan/komentar/${id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
}

export default new PelatihanKomentarService();
